/**
 * @generated SignedSource<<502ecc1f230b7674a7d1035c4e25164c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useCreateSharedDeviceAuthRequestMutation$variables = {
  storeId?: string | null;
};
export type useCreateSharedDeviceAuthRequestMutation$data = {
  readonly store: {
    readonly createSharedMobileDeviceAuthRequest: {
      readonly deviceCode: string;
      readonly expiresAtDate: {
        readonly isoString: string;
      };
    };
  };
};
export type useCreateSharedDeviceAuthRequestMutation = {
  response: useCreateSharedDeviceAuthRequestMutation$data;
  variables: useCreateSharedDeviceAuthRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SharedMobileDeviceAuthRequest",
        "kind": "LinkedField",
        "name": "createSharedMobileDeviceAuthRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deviceCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "expiresAtDate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoString",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateSharedDeviceAuthRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateSharedDeviceAuthRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "facfa1abb91c88c2c27d99031b132257",
    "id": null,
    "metadata": {},
    "name": "useCreateSharedDeviceAuthRequestMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateSharedDeviceAuthRequestMutation(\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    createSharedMobileDeviceAuthRequest {\n      deviceCode\n      expiresAtDate {\n        isoString\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1422c1b5dab451c3dc9e6ee684ff4a66";

export default node;
